/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OIDCChallengeOptions
 */
export interface OIDCChallengeOptions {
    /**
     * 
     * @type {string}
     * @memberof OIDCChallengeOptions
     */
    auth_code_url: string;
}

/**
 * Check if a given object implements the OIDCChallengeOptions interface.
 */
export function instanceOfOIDCChallengeOptions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "auth_code_url" in value;

    return isInstance;
}

export function OIDCChallengeOptionsFromJSON(json: any): OIDCChallengeOptions {
    return OIDCChallengeOptionsFromJSONTyped(json, false);
}

export function OIDCChallengeOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OIDCChallengeOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'auth_code_url': json['auth_code_url'],
    };
}

export function OIDCChallengeOptionsToJSON(value?: OIDCChallengeOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'auth_code_url': value.auth_code_url,
    };
}

